<template>
  <div v-if="intent" id="manage-intent">
    <div>
      <v-layout v-if="!isWelcome" wrap style="border-bottom: 1px solid #eee" class="mb-3">
        <v-flex
          v-if="intent.intentname !== '{first_announcement_message}'"
          xs12
          sm5
          md6
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="px-2 pt-2"
        >
          <template v-if="readonlyName || isDefault">
            <p>{{ intentLabel(intent.intentname) }}</p>
          </template>
          <div v-else>
            <template v-if="!isBeacon">
              <input
                v-model="intent.intentname"
                v-validate="
                  'required|excludednew:{default},{welcome}' +
                  (excludedName ? ',' + excludedName : '')
                "
                type="text"
                :readonly="isReadonly"
                class="form-control"
                :placeholder="$t('Conversation')"
                name="intentName"
                :data-vv-as="$t('Conversation')"
                aria-describedby="Intent Name"
              />
            </template>
            <template v-else>
              <input
                v-if="!isDefault"
                v-model="intent.campaign_name"
                v-validate="
                  'required|excludednew:{default},{welcome}' +
                  (excludedName ? ',' + excludedName : '')
                "
                type="text"
                class="form-control"
                :placeholder="$t('Conversation')"
                name="intentName"
                :data-vv-as="$t('Conversation')"
                aria-describedby="Intent Name"
              />
            </template>
          </div>

          <span v-show="errors.has('intentName')" class="text-error">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex v-if="!livechat" xs12 sm7 md6 class="px-2 pt-2">
          <slot name="action"></slot>
          <div v-if="showReplyCommentSelectPost" class="text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn color="primary" small outline @click="showSelectPost = true">
                <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
                <v-icon small>edit</v-icon>
              </v-btn>
              <intent-select-post
                :include-post="intent.postidlist"
                :exclude-post="intent.exceptpostidlist"
                :post_keywords="intent.post_keywords"
                :show="showSelectPost"
                :useexclude="true"
                @save="saveFilterPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>

            <v-btn v-else color="grey" disabled outline>
              <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn>
          </div>
        </v-flex>
        <v-flex v-if="!livechat" xs12 class="px-2 pt-1 pb-2" align-end>
          <v-layout row wrap>
            <v-flex xs6 class="text-xs-left">
              <template v-if="!hideStatus">
                <toggle-button
                  v-if="!isBeacon"
                  :value="intent.intentstatus"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  @change="onChangeIntentStatus"
                />
                <span v-if="!isBeacon" class="mr-2">{{ $t('Turn On/Off Conversation') }}</span>
              </template>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap justify-end class="py-0 my-0">
                <div v-if="!hidePriority">
                  <v-checkbox
                    v-model="intent.ispriority"
                    class="my-0 py-0"
                    hide-details
                    color="success"
                    :label="$t('First Priority')"
                  ></v-checkbox>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex v-if="!livechat" xs12 sm6 class="pa-1 pl-2 pr-2">
          <template v-if="!isDefault && !hideQuestion">
            <template v-if="isBeacon && $route.name === 'beacon'">
              <intent-question-beacon
                ref="intentQuestion"
                v-model="beaconData"
              ></intent-question-beacon>
            </template>
            <template v-else>
              <intent-question
                ref="intentQuestion"
                v-model="intent.q_val"
                :is-event-purchase="
                  Boolean(intent.event_setting && intent.event_setting.event_name)
                "
                @onClickVerifySlip="onClickVerifySlip"
                @onClickClearVerifySlip="onClickClearVerifySlip"
              ></intent-question>
            </template>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px"></p>
          </template>
        </v-flex>
        <v-flex xs12 :sm6="!livechat" :sm12="livechat" class="pa-1">
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-comment
              v-model="messages"
              :is-live-stream="isLiveStream"
              :intentname="intent.intentname"
            ></intent-comment>
          </template>
          <template v-else-if="isWelcome && !showMultipleChannel">
            <slot name="welcome" v-bind="{ showMultipleChannel, changeSetting }"></slot>
          </template>
          <template v-else>
            <v-layout>
              <v-flex
                v-if="showMultipleChannel"
                class="channel"
                shrink
                style="border-right: 1px solid #eee"
              >
                <template v-for="social in conversationSocialChannelOptions">
                  <div
                    :key="social.value"
                    :class="{ 'primary white--text': tab == social.value }"
                    class="py-1 pl-2 pr-2"
                    style="
                      border: 1px solid #eee;
                      border-width: 1px 0px 1px 1px;
                      border-top-left-radius: 5px;
                      border-bottom-left-radius: 5px;
                      cursor: pointer;
                    "
                    @click="tab = social.value"
                  >
                    <span :class="social.icon"></span>
                  </div>
                </template>
              </v-flex>
              <v-flex :key="timestamp" style="overflow: auto">
                <template v-if="intent.intentname === '{first_announcement_message}'">
                  <span>
                    {{ $t(`Turn On/Off Date & Time Setting for Bot's Reply`) }}
                  </span>
                  <v-flex class="mt-2">
                    <div class="form-control">
                      <div class="caption">{{ $t('Turn-on Time') }}</div>
                      <v-layout wrap>
                        <v-flex
                          xs6
                          class="form-control"
                          :class="{ 'has-error': errors.has('startdate') }"
                        >
                          <v-menu
                            ref="openStartDate"
                            v-model="openStartDate"
                            :close-on-content-click="false"
                            full-width
                            max-width="290px"
                            color="primary"
                          >
                            <template #activator="{ on }">
                              <input
                                v-model="startDate"
                                type="text"
                                class="form-control browser-default"
                                :placeholder="$t('Date')"
                                readonly
                                clearable
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="startDate"
                              color="primary"
                              @input="handleStartdate()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs4 class="pl-1">
                          <time-picker-custom
                            v-model="startTimeInput"
                            max="23:59"
                            :disabled="startDate === null"
                            @input="handleStartTime()"
                          >
                          </time-picker-custom>
                          <!-- <time-picker
                            v-model="startTime"
                            :key="`setstarttime_${timestamp}`"
                            full-width
                            :disabled="startDate == null"
                            :placeholder="$t('Time')"
                            :hide-clear-button="true"
                          ></time-picker> -->
                        </v-flex>
                        <v-flex xs2>
                          <v-btn
                            fab
                            flat
                            small
                            color="primary"
                            style="height: 35px; width: 35px"
                            @click="
                              startDate = null
                              startTime = null
                              changeTimestamp()
                            "
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                  <v-flex>
                    <div class="form-control">
                      <div class="caption">{{ $t('Turn-off Time') }}</div>
                      <v-layout wrap>
                        <v-flex
                          class="form-control"
                          xs6
                          :class="{ 'has-error': errors.has('enddate') }"
                        >
                          <v-menu
                            ref="openEndDate"
                            v-model="openEndDate"
                            :close-on-content-click="false"
                            full-width
                            max-width="290px"
                            color="primary"
                          >
                            <template #activator="{ on }">
                              <input
                                v-model="endDate"
                                type="text"
                                class="form-control browser-default"
                                :placeholder="$t('Date')"
                                readonly
                                clearable
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="endDate"
                              color="primary"
                              @input="handleEndDate()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs4 class="pl-1">
                          <time-picker-custom
                            v-model="endTimeInput"
                            :disabled="endDate === null"
                            @input="handleEndTime()"
                          >
                          </time-picker-custom>
                          <!-- <time-picker
                            :key="`setendtime_${timestamp}`"
                            v-model="endTime"
                            :disabled="endDate == null"
                            full-width
                            format="HH:mm"
                            :placeholder="$t('Time')"
                            :hide-clear-button="true"
                          ></time-picker> -->
                          <!-- <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu> -->
                        </v-flex>
                        <v-flex xs2>
                          <v-btn
                            fab
                            flat
                            small
                            color="primary"
                            style="height: 35px; width: 35px"
                            @click="
                              endDate = null
                              endTime = null
                              changeTimestamp()
                            "
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>

                  <intent-group
                    v-model="messages"
                    :intentname="intent.intentname"
                    :channel="tab"
                    :is-first-announcement="intent.intentname === '{first_announcement_message}'"
                    @changeSetting="changeSetting"
                  ></intent-group>
                </template>
                <template v-else-if="!showMultipleChannel">
                  <template v-if="isBeacon">
                    <intent-group-beacon
                      v-model="alternativeGroupMessages"
                      :beacon-quick-replies="beaconQuickReplies"
                      :intentname="intent.intentname"
                      :show-multiple-channel="showMultipleChannel"
                      :channel="tab"
                      :hide-setting="hideSetting"
                      :available-bubbles="availableBubbles"
                      :is-beacon="isBeacon"
                      @changeSetting="changeSetting"
                      @updateQuickReply="handleUpdateBeaconQuickReply"
                      @onCurrentPreview="handleSetBeaconPreviewIntent"
                    ></intent-group-beacon>
                  </template>
                  <template v-else>
                    <intent-group
                      v-model="messages"
                      :intentname="intent.intentname"
                      :show-multiple-channel="showMultipleChannel"
                      :channel="tab"
                      :hide-setting="hideSetting"
                      :available-bubbles="availableBubbles"
                      :is-beacon="isBeacon"
                      :question="intent.q_val"
                      :verify-slip-setting.sync="intent.verify_slip_setting"
                      @changeSetting="changeSetting"
                    ></intent-group>
                  </template>
                </template>
                <template v-else>
                  <template v-for="social in conversationSocialChannelOptions">
                    <div v-show="social.value == tab" :key="`message-${social.value}`">
                      <keep-alive>
                        <intent-group
                          :key="`${social.value}_message`"
                          v-model="multiMessages[`${social.value}_messages`]"
                          :intentname="intent.intentname"
                          :show-multiple-channel="showMultipleChannel"
                          :channel="tab"
                          :hide-setting="hideSetting"
                          :available-bubbles="availableBubbles"
                          :question="intent.q_val"
                          :verify-slip-setting.sync="intent.verify_slip_setting"
                          @changeSetting="changeSetting"
                        ></intent-group>
                      </keep-alive>
                    </div>
                  </template>
                </template>
              </v-flex>
            </v-layout>
            <template v-if="!isWelcome && !isCommentToInbox && !livechat && !hideChoice">
              <div class="hr"></div>
              <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>

              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  style="margin-bottom: 5px"
                  :btn-text="$t('Add choice')"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <span v-if="errorTag.length > 0" class="text-error">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </template>
            <template v-else></template>
          </template>
        </v-flex>
      </v-layout>

      <div v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)" class="my-3">
        <div class="mt-4">
          <div class="pa-3">
            <div class="caption pb-2">Conversation Grouping</div>
            <div class="form-control" :class="{ 'has-error': errors.has('uuAreaName') }">
              <multiselect
                v-model="intent.group_conversation_id"
                :options="groupConversation"
                select-label
                selected-label
                :searchable="true"
                deselect-label
                label="name"
                track-by="id"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <template v-if="selectedBot.theme == 'universalutilities'">
        <template v-if="selectedBot.uu_areaname != '' && selectedBot.uu_areaname != null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control">
                <span class="primary--text">{{ selectedBot.uu_areaname }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="selectedBot.uu_areaname == '' || selectedBot.uu_areaname == null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control" :class="{ 'has-error': errors.has('uuAreaName') }">
                <multiselect
                  v-model="intent.intentgroup"
                  :options="areaName"
                  select-label
                  selected-label
                  :searchable="false"
                  deselect-label
                  data-vv-as="ประปา"
                  data-vv-name="uuAreaName"
                ></multiselect>
                <span v-show="errors.has('uuAreaName')" class="text-error">{{
                  errors.first('uuAreaName')
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-if="isRoots">
        <div class="my-3 pa-1">
          <v-layout wrap>
            <v-flex xs6>
              <div class="caption pb-2">{{ $t('company') }}</div>
              <div class="form-control" :class="{ 'has-error': errors.has('rootsCompany') }">
                <multiselect
                  v-model="intent.roots_company_id"
                  :options="rootsCompanyOptions"
                  name="rootsCompany"
                  :searchable="true"
                  select-label
                  selected-label
                  deselect-label
                  label="name"
                  track-by="id"
                  :data-vv-as="$t('company')"
                  data-vv-name="rootsCompany"
                ></multiselect>
                <span v-show="errors.has('rootsCompany')" class="text-error">{{
                  errors.first('rootsCompany')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </template>

      <template v-if="selectedBot.theme == 'mitsuwebchat'">
        <div class="mt-4">
          <div class="hr"></div>
          <div class="pa-3">
            <div class="caption">{{ $t('Department') }}</div>
            <div
              v-if="$store.state.privilege.role == 'superadmin'"
              class="form-control"
              :class="{ 'has-error': errors.has('mitsuDepartment') }"
            >
              <multiselect
                v-model="intent.intentgroup"
                :options="agentGroup"
                track-by="groupname"
                label="groupname"
                name="mitsuDepartment"
                :searchable="true"
                select-label
                selected-label
                deselect-label
                :data-vv-as="$t('Department')"
                data-vv-name="mitsuDepartment"
              ></multiselect>
              <span v-show="errors.has('mitsuDepartment')" class="text-error">{{
                errors.first('mitsuDepartment')
              }}</span>
            </div>
            <div v-else>
              <span>{{ intent.intentgroup.groupname }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="selectedBot && selectedBot.type === 'hopinnhr'">
        <div class="mt-4 form-control">
          <div class="hr"></div>
          <div class="pa-3">
            <v-layout wrap>
              <v-flex xs6 class="pr-2">
                <div class="caption">ตำแหน่ง</div>
                <div>
                  <multiselect
                    v-model="intent.custom_filter_2"
                    track-by="engname"
                    label="engname"
                    :options="positionOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :open-direction="'bottom'"
                    select-label
                    selected-label
                  ></multiselect>
                </div>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <div class="caption">สังกัด</div>
                <div>
                  <multiselect
                    v-model="intent.custom_filter_1"
                    track-by="engname"
                    label="engname"
                    :options="affiliationOptions"
                    :allow-empty="true"
                    :searchable="false"
                    :open-direction="'bottom'"
                    select-label
                    selected-label
                  ></multiselect>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </template>
      <template v-if="isJuzmatchSale || isJuzmatchCrm">
        <div class="mt-4 form-control">
          <div class="hr"></div>
          <div class="pa-3">
            <v-layout wrap>
              <v-flex xs6 class="pr-2">
                <div class="caption">role</div>
                <div>
                  <multiselect
                    v-model="intent.intent_member_type"
                    :options="roleJuzMatchMasterData"
                    :searchable="true"
                    :open-direction="'bottom'"
                    track-by="id"
                    label="name"
                    select-label
                    selected-label
                    deselect-label
                  ></multiselect>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </template>
      <template v-if="isGpfBuddy">
        <div class="mt-4">
          <div class="hr"></div>
          <div class="py-4 px-2">
            <v-layout row wrap>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('company') }}</div>
                  <div>
                    <multiselect
                      v-model="intent.gpf_company_code"
                      :options="gpfBuddyOption.companies"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="company_code"
                      label="company_name"
                      @input="onChangeGpfBuddyOptions('company')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('work_group') }}</div>
                  <div>
                    <multiselect
                      v-model="intent.gpf_group_code"
                      :disabled="
                        intent.gpf_company_code && intent.gpf_company_code.company_code === 'All'
                      "
                      :options="gpfBuddyOption.groups"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="group_code"
                      label="group_name"
                      @input="onChangeGpfBuddyOptions('group')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('department') }}</div>
                  <div>
                    <multiselect
                      v-model="intent.gpf_department_code"
                      :disabled="
                        intent.gpf_group_code && intent.gpf_group_code.group_code === 'All'
                      "
                      :options="gpfBuddyOption.departments"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="department_code"
                      label="department_name"
                      @input="onChangeGpfBuddyOptions('department')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('position') }}</div>
                  <div>
                    <multiselect
                      v-model="intent.gpf_position_code"
                      :disabled="
                        intent.gpf_department_code &&
                        intent.gpf_department_code.department_code === 'All'
                      "
                      :options="gpfBuddyOption.positions"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="position_code"
                      label="position_name"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </template>

      <template v-if="isAssetWise">
        <div class="my-3 px-2 py-1 text-xs-left">
          <div>{{ $t('asset_wise.role') }}</div>
          <AssetWiseRoleSelect v-model="conversationGroups" />
        </div>
      </template>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            style="position: relative"
            @click="onShowAdvance"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            />
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <template>
          <div
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
            style="margin-top: 25px"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
              <v-tab v-if="showAdvancedMenu('customer')" key="customer" href="#customer" ripple>{{
                $t('Customer')
              }}</v-tab>
              <template v-if="intent.intentname !== '{first_announcement_message}'">
                <v-tab
                  v-if="
                    !isCommentToInbox && !isLiveStream && showAdvancedMenu('context') && !isBeacon
                  "
                  key="context"
                  href="#context"
                  ripple
                >
                  {{ $t('Context') }}
                </v-tab>
                <v-tab
                  v-if="showAdvancedMenu('timer') && !isBeacon"
                  v-show="!livechat"
                  key="timer"
                  href="#timer"
                  ripple
                  >{{ $t('Timer') }}</v-tab
                >
                <v-tab
                  v-if="showAdvancedMenu('line_notify') && !isBeacon"
                  v-show="!livechat"
                  key="line_notify"
                  href="#line_notify"
                  ripple
                  >{{ $t('Line Notify') }}</v-tab
                >
                <v-tab
                  v-if="showAdvancedMenu('limit_reply_to_inbox') && !isBeacon"
                  v-show="
                    false &&
                    isCommentToInbox &&
                    !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                  "
                  key="limit_reply_to_inbox"
                  href="#limit_reply_to_inbox"
                  ripple
                  >{{ $t('Limit reply to inbox') }}</v-tab
                >
                <v-tab
                  v-if="showIntentGroup && !livechat && !isBeacon"
                  key="intent_group"
                  href="#intent_group"
                  ripple
                >
                  {{ $t('Intent Group') }}
                </v-tab>
                <v-tab v-if="isBeacon" key="frequency" href="#frequency" ripple>{{
                  $t('frequency')
                }}</v-tab>

                <v-tab
                  v-if="showAdvancedMenu('follow_up') && !isCommentToInbox"
                  key="follow_up"
                  href="#follow_up"
                  ripple
                  >{{ $t('Follow Up') }}</v-tab
                >

                <v-tab
                  v-if="showAdvancedMenu('bot_profile') && !isCommentToInbox"
                  key="bot_profile"
                  href="#bot_profile"
                  ripple
                >
                  {{ $t('bot_profile') }}
                </v-tab>

                <v-tab
                  v-if="isRichMenuEnabled && selectedBot.line_access_token && !isCommentToInbox"
                  key="rich_menu"
                  href="#rich_menu"
                  ripple
                >
                  LINE Rich Menu
                </v-tab>

                <v-tab
                  v-if="
                    !livechatapp &&
                    !isBeacon &&
                    !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
                    isFacebookConversionConnected
                  "
                  key="purchase_event"
                  href="#purchase_event"
                  ripple
                >
                  {{ $t('purchase_event') }}
                  <a
                    class="primary--text"
                    @click="openLink('https://blog.zwiz.app/สูตรลับ-23-วิธีเช็ค-conversion-รู้ทั/')"
                    ><i style="font-size: 18px" class="ml-1 fas fa-question-circle"></i
                  ></a>
                </v-tab>

                <v-tab v-if="isSrichand" key="user-status" href="#user-status" ripple>
                  {{ $t('user_status') }}
                </v-tab>

                <v-tab
                  v-if="isEventTrackingEnabled"
                  key="event-tracking"
                  href="#event-tracking"
                  ripple
                >
                  {{ $t('Event Tracking') }}
                </v-tab>
              </template>
            </v-tabs>
            <div v-show="advancedTab == 'customer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="form-control">
                    <div class="primary--text caption">{{ $t('Status') }}</div>
                    <v-layout wrap>
                      <v-flex sm11>
                        <multiselect
                          v-model="intent.userstatus"
                          :options="statusOptions"
                          :multiple="false"
                          :taggable="true"
                          @tag="onSelectStatus"
                        >
                        </multiselect>
                      </v-flex>
                      <v-flex sm1>
                        <v-btn color="primary" samll icon @click="intent.userstatus = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div class="mb-2">
                    <div class="primary--text caption mb-2">{{ $t('Add tag') }}</div>
                    <tags
                      v-if="tagOptions"
                      v-model="usertag"
                      :combobox="true"
                      :tags="usertags"
                      :item-option="tagOptions"
                      style="margin-bottom: 5px"
                      :btn-text="$t('Add tag')"
                      @tags-changed="addUserTags"
                      @before-adding-tag="checkUserTags"
                      @onSearch="onSearchTag"
                    ></tags>
                    <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="primary--text caption mb-2">{{ $t('Remove tag') }}</div>
                    <tags
                      v-if="tagOptions"
                      v-model="usertag"
                      :combobox="true"
                      :tags="deleteUserTags"
                      :item-option="tagOptions"
                      style="margin-bottom: 5px"
                      :btn-text="$t('Remove tag')"
                      @tags-changed="addDeleteUserTags"
                      @before-adding-tag="checkUserTags"
                      @onSearch="onSearchTag"
                    ></tags>
                    <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div
              v-if="!isCommentToInbox && !isLiveStream && !isBeacon"
              v-show="advancedTab == 'context'"
            >
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm6
                      class="form-control pr-1"
                      :class="{ 'has-error': errors.has('context_in') }"
                    >
                      <template v-if="isLiveStream">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('facebooklive')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else-if="isCommentToInbox">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('Comment')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else>
                        <input
                          v-model="intent.context_in"
                          v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                          style="margin-bottom: 5px"
                          type="text"
                          class="form-control"
                          placeholder="Context In"
                          data-vv-as="Context In"
                          name="context_in"
                        />
                        <span v-show="errors.has('context_in')" class="text-error">{{
                          $t('Context In cannot be Comment')
                        }}</span>
                      </template>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-control pl-1">
                      <input
                        v-model="intent.context_out"
                        type="text"
                        class="form-control"
                        placeholder="Context Out"
                      />
                    </v-flex>
                  </v-layout>
                  <div class="caption">
                    {{ $t('Learn more') }}
                    <a
                      href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ $t('click here') }}</a
                    >
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!isBeacon" v-show="advancedTab == 'timer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text v-if="intent.intentname !== '{first_announcement_message}'">
                  <v-radio-group v-model="intent.onlytime" @change="changeOnlytime">
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Selecting certain chatbot's answers for the certain time`)"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      :color="'primary'"
                      :label="$t(`select_by_date_and_time`)"
                      :value="null"
                    ></v-radio>
                  </v-radio-group>
                  <v-layout v-if="intent.onlytime">
                    <v-flex class="pr-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <v-menu
                              ref="openStartTime"
                              v-model="openStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value="startTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="startTime"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openStartTime"
                                v-model="startTime"
                                full-width
                                @click:minute="$refs.openStartTime.save(startTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <v-menu
                              ref="openEndTime"
                              v-model="openEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value="endTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="endTime"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openEndTime"
                                v-model="endTime"
                                full-width
                                @click:minute="$refs.openEndTime.save(endTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else-if="intent.onlytime === false">
                    <v-flex class="pr-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            xs6
                            class="form-control"
                            :class="{ 'has-error': errors.has('startdate') }"
                          >
                            <v-menu
                              ref="openStartDate"
                              v-model="openStartDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="startDate"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  clearable
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="startDate"
                                color="primary"
                                @input="openStartDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <v-menu
                              ref="openStartTime"
                              v-model="openStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value="startTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :disabled="startDate == null"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="startTime"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  :disabled="startDate == null"
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openStartTime"
                                v-model="startTime"
                                full-width
                                @click:minute="$refs.openStartTime.save(startTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            class="form-control"
                            xs6
                            :class="{ 'has-error': errors.has('enddate') }"
                          >
                            <v-menu
                              ref="openEndDate"
                              v-model="openEndDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="endDate"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  clearable
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="endDate"
                                color="primary"
                                @input="openEndDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <v-menu
                              ref="openEndTime"
                              v-model="openEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value="endTime"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :disabled="endDate == null"
                            >
                              <template #activator="{ on }">
                                <input
                                  v-model="endTime"
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Time')"
                                  readonly
                                  :disabled="endDate == null"
                                  v-on="on"
                                />
                              </template>
                              <v-time-picker
                                v-if="openEndTime"
                                v-model="endTime"
                                full-width
                                @click:minute="$refs.openEndTime.save(endTime)"
                              ></v-time-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="intent.onlytime === null && intent.time_setting">
                    <v-flex>
                      <template v-for="(time, key) in intent.time_setting">
                        <open-time-bot-item
                          :key="key"
                          v-model="intent.time_setting[key]"
                          :name="key"
                          :is-edit="true"
                        ></open-time-bot-item>
                      </template>
                    </v-flex>
                  </v-layout>

                  <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                    <input
                      v-model="startTimeFormat"
                      v-validate="endTimeFormat ? '' : ''"
                      type="hidden"
                      :data-vv-as="$t('Start date')"
                      name="startdate"
                    />
                    <input
                      ref="beforeTarget"
                      v-model="endTimeFormat"
                      :data-vv-as="$t('End date')"
                      name="enddate"
                      type="hidden"
                    />

                    <span v-if="errors.has('startdate')" class="text-error">
                      {{ errors.first('startdate') }}
                    </span>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!isBeacon" v-show="advancedTab == 'line_notify'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium'"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="col s8">
                    <div class="primary--text caption">{{ $t('Line Notify') }}</div>
                  </div>
                  <div class="col s4 text-xs-right">
                    <template v-if="$store.state.linenotifylist.length == 0"></template>
                    <template
                      v-if="
                        [
                          'ticket',
                          'ticket2',
                          'studio7',
                          'ustore',
                          'tdtawandang',
                          'cityfresh',
                          ...$store.state.ticketThemeList
                        ].includes(selectedBot.theme) ||
                        $store.state.ticketPageid.includes(selectedBot.pageid) ||
                        (['gpf', 'mtc', 'uu'].includes(selectedBot.type) &&
                          ((selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)))
                      "
                    >
                      <label
                        class="toggle-switch small"
                        style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                      >
                        <input
                          type="checkbox"
                          :checked="intent.linenoti_status"
                          @change="toggleLineNotifyStatus"
                        />
                        <span class="toggle-slider lever round"></span>
                      </label>
                    </template>
                  </div>
                  <div class="col s12 form-control">
                    <template v-if="$store.state.linenotifylist.length == 0">
                      {{ $t('You are not connected to Line Notify.') }}
                      <router-link to="setting">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                        (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <input
                        v-model="intent.linenoti_text"
                        type="text"
                        class="form-control"
                        :placeholder="$t('Message')"
                        maxlength="250"
                      />
                    </template>
                    <template v-else>
                      {{ $t('Not yet alert via Line Notify.') }}
                      <router-link to="setting">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!isBeacon" v-show="advancedTab == 'limit_reply_to_inbox'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium'"
                  :show-all="false"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div
                    class="py-1 px-3 info white--text caption"
                    style="border-radius: 25px; display: inline-block"
                  >
                    ฟีเจอร์นี้ยังอยู่ในระหว่างการทดลอง Beta เปิดให้ใช้งานชั่วคราว
                  </div>

                  <div class="col s12 form-control">
                    <v-checkbox
                      v-model="isremainingreply"
                      color="primary"
                      :label="$t('Reply to comment (amount)')"
                      hide-details
                      @change="changeRemainingReply"
                    ></v-checkbox>
                    <input
                      v-model="remaining_reply"
                      type="number"
                      class="mt-2"
                      :disabled="!isremainingreply"
                      :placeholder="$t('Amount2')"
                    />
                    <v-checkbox
                      v-model="notreplysameperson"
                      color="primary"
                      :label="$t('Reply once/person')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!isBeacon" v-show="advancedTab == 'intent_group'">
              <v-card flat>
                <v-card-text>
                  <template v-if="showAdvancedIntentGroup">
                    <template v-if="!loadingIntentGroup">
                      <ManageIntentTicket3Group
                        v-if="selectedBot && selectedBot.unlock_ticket_3"
                        :ticket="ticket"
                        @updateInput="handleUpdateTicketInput"
                      />
                      <ManageIntentTicketGroup
                        v-else
                        :ticket="ticket"
                        @updateInput="handleUpdateTicketInput"
                      />
                    </template>
                  </template>
                  <template v-else>
                    <div>
                      <div class="form-control">
                        <div class="primary--text caption">{{ $t('Intent Group') }}</div>
                        <input
                          v-model="intent.intentgroup"
                          type="text"
                          class="form-control"
                          :placeholder="$t('Intent Group')"
                          maxlength="600"
                        />
                      </div>
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </div>
            <v-tab-item v-if="isBeacon" v-show="advancedTab === 'frequency'">
              <template v-if="intent">
                <IntentBeaconFrequency v-model="intent" />
              </template>
            </v-tab-item>
            <div v-show="advancedTab == 'follow_up'">
              <v-card flat>
                <v-card-text>
                  <template v-if="intent">
                    <FollowUpMessages
                      :intent="intent"
                      :tab="tab"
                      :is-reply-comment="isReplyComment"
                      :is-comment-to-inbox="isCommentToInbox"
                      :is-welcome="isWelcome"
                      :timestamp="timestamp"
                      :status-options="statusOptions"
                      :tag-options="tagOptions"
                      @changeSetting="changeFollowUpSetting"
                    />
                  </template>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="advancedTab == 'bot_profile'">
              <ManageBotProfileVue :intent="intent" @onSelectBotProfile="handleSelectBotProfile" />
            </div>
            <div v-if="advancedTab == 'purchase_event'">
              <PurchaseEventManagement
                :key="purchaseEventManagementKey"
                :intent="intent"
                @input="handlePurchaseEventManagementInput"
              />
            </div>
            <div v-if="advancedTab == 'rich_menu'">
              <RichMenuForm
                :value="intent.line_rich_menu_setting || undefined"
                @input="intent.line_rich_menu_setting = $event"
              />
            </div>
            <div v-if="advancedTab == 'user-status'">
              <UserStatusForm
                :value="intent.user_states || undefined"
                @input="intent.user_states = $event"
              />
            </div>
            <div v-if="advancedTab == 'event-tracking'">
              <EventTrackingForm
                :value="intent.event_tracking || undefined"
                @input="intent.event_tracking = $event"
              />
            </div>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <input
          v-model="intent.q_val"
          v-validate="
            !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
            !hideQuestion
              ? 'required'
              : ''
          "
          type="hidden"
          :data-vv-as="$t('customer says')"
          name="q_val"
        />

        <div class="form-control has-error" style="margin-bottom: 10px">
          <span v-if="errors.has('intentName')" class="text-error">{{
            errors.first('intentName')
          }}</span>
          <span v-else-if="errors.has('q_val')" class="text-error">{{
            errors.first('q_val')
          }}</span>
          <span v-else-if="errors.has('bubbleLimit')" class="text-error">{{
            errors.first('bubbleLimit')
          }}</span>
          <span v-else-if="errorTag.length > 0" class="text-error">
            <template v-if="errorTag.includes('overmaxlength')">{{
              $t('Message cannot be longer than 20 alphabets')
            }}</template>
            <template v-else-if="errorTag.includes('overtagmax')">{{
              $t('Choices cannot be more than 10 items')
            }}</template>
            <template v-else-if="errorTag.includes('duplicate')">{{
              $t('Duplicate Choice')
            }}</template>
          </span>
          <span v-else-if="errorUserTags.length > 0" class="text-error">
            <template v-if="errorUserTags.includes('duplicate')">{{
              $t('Duplicate Tag')
            }}</template>
          </span>

          <span v-else-if="errors.has('context_in')" class="text-error">{{
            $t('Context In cannot be Comment')
          }}</span>
          <span v-else-if="errors.has('startdate')" class="text-error">{{
            errors.first('startdate')
          }}</span>
        </div>
        <slot name="footer" :save-intent="saveIntent" :cancel-edit="cancelEdit">
          <div style="margin-bottom: 15px">
            <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
              <em class="far fa-eye" />
              {{ $t('preview') }}
            </a>
            <preview-message
              v-if="showPreview"
              :messages="previewMessage"
              :choice="replies"
              :questions="questions"
              :is-comment="isCommentToInbox"
              :comment="replyComment"
              @close="showPreview = false"
            ></preview-message>
          </div>
          <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
          <v-btn v-if="ticket2showsave" depressed color="primary" @click="saveIntent">{{
            $t('Save')
          }}</v-btn>
          <v-btn v-if="livechat" dark depressed color="#366cd1" @click="sendToLivechat">{{
            $t('Send')
          }}</v-btn>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import PreviewMessage from '@/components/elements/PreviewMessage'
import Tags from '@/components/elements/Tags'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import FollowUpMessages from './FollowUpMessages'
import IntentComment from './IntentComment'
import IntentGroup from './IntentGroup'
import IntentGroupBeacon from './IntentGroupBeacon'
import IntentQuestion from './IntentQuestion'
import IntentQuestionBeacon from './IntentQuestionBeacon'
import IntentSelectPost from './IntentSelectPost'
import IntentSelectPostLabel from './IntentSelectPostLabel'
// import IntentSelectBeacon from './IntentSelectBeacon'
import intentApi from '@/api/intent.js'
import beaconApi from '@/api/beacon'
import { handleResponse, handleApiError } from '@/api/util'

import { Validator } from 'vee-validate'
import ticketApi from '@/api/ticket'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import TimePickerCustom from '@/components/elements/TimePickerCustom.vue'

import IntentBeaconFrequency from './IntentBeaconFrequency'

import AssetWiseRoleSelect from './AssetWiseRoleSelect.vue'
import ManageIntentTicket3Group from './Ticket3/ManageIntentTicketGroup'
import ManageIntentTicketGroup from './Ticket/ManageIntentTicketGroup'

import ManageBotProfileVue from '../../elements/BotProfile/ManageBotProfile.vue'

import OpenTimeBotItem from '../billing/OpenTimeBotItem.vue'
import PurchaseEventManagement from './PurchaseEventManagement.vue'
import RichMenuForm from './RichMenuForm'
import UserStatusForm from './UserStatusForm'
import EventTrackingForm from './EventTrackingForm'
import { FEATURE } from '@/constants/feature'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  components: {
    IntentGroup,
    IntentGroupBeacon,
    IntentComment,
    Tags,
    PreviewMessage,
    IntentSelectPost,
    IntentQuestion,
    IntentQuestionBeacon,
    Multiselect,
    ToggleButton,
    IntentSelectPostLabel,
    FollowUpMessages,

    IntentBeaconFrequency,

    AssetWiseRoleSelect,
    ManageIntentTicket3Group,
    ManageIntentTicketGroup,
    ManageBotProfileVue,
    // IntentSelectBeacon,
    OpenTimeBotItem,
    TimePickerCustom,
    PurchaseEventManagement,
    RichMenuForm,
    UserStatusForm,
    EventTrackingForm
  },
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    },
    isLiveStream: {
      type: Boolean,
      default: false
    },
    livechat: {
      type: Boolean,
      default: false
    },
    hideQuestion: {
      default: false
    },
    hideSetting: {
      default: false
    },
    hidePriority: {
      default: false
    },
    readonlyName: {
      default: false
    },
    hideAdvanceOptions: {
      default: null
    },
    availableBubbles: {},

    hideChoice: {
      default: false
    },
    hideStatus: {
      default: false
    },
    isBeacon: {
      type: Boolean,
      default: false
    },
    livechatapp: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      statusOptions: [],
      tagOptions: null,
      tagssearch: null,
      showDueTimeDialog: false,
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      tab: 'all',
      showMultipleChannel: false,
      tagediting: null,
      postidlist: { includes: [], excludes: [], post_keywords: [] },
      advancedTab: null,
      showSelectPost: false,
      showSelectBeacon: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      reply: '',
      text: '',
      messages: [[]],
      multiMessages: {},
      multiReplies: {},
      multiStringReplies: {},

      errorTag: [],
      errorUserTags: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],
      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10,
      isremainingreply: false,
      remaining_reply: null,
      notreplysameperson: false,
      ticket: {
        assigngroupid: '',
        assignsubgroupid: '',
        priority: '',
        group: '',
        subgroup: '',
        tags: [],
        day: 0,
        hour: 0,
        minute: 0,
        duedate: {
          start: '',
          starttime: '',
          end: ''
        },
        mood: ''
      },
      tagitems: [{ header: 'Select an option or create one' }],
      showDueDate: false,
      timestamp: moment().format('x'),
      isShowIntentGroup: false,
      positionOptions: [],
      affiliationOptions: [],
      showMultipleChannelFollowUp: false,
      gpfBuddyOption: {
        positions: [],
        companies: [],
        departments: [],
        groups: []
      },
      isDirtyTagManagement: false,
      alternativeGroupMessages: [],
      beaconQuickReplies: [],
      beaconData: {},
      beaconCurrentIntentItems: [[]],
      conversationGroups: [],
      loadingIntentGroup: false,
      purchaseEventManagementKey: 0
    }
  },
  computed: {
    showAdvancedIntentGroup() {
      return (
        [
          'ticket',
          'ticket2',
          'studio7',
          'ustore',
          'tdtawandang',
          'cityfresh',
          'nestle',
          ...this.$store.state.ticketThemeList
        ].includes(this.selectedBot.theme) ||
        [
          ...this.$store.state.ticketPageid,
          ...this.$store.state.rabbitReplyFBPostPage,
          ...this.$store.state.toaPaintPage
        ].includes(this.selectedBot.pageid) ||
        ['gpf', 'mtc'].includes(this.selectedBot.type) ||
        (this.selectedBot && this.selectedBot.unlock_ticket_3)
      )
    },
    showIntentGroup() {
      return (
        (!this.isCommentToInbox &&
          this.$store.getters.showIntentGroup &&
          this.showAdvancedMenu('intent_group')) ||
        (this.isCommentToInbox &&
          [...this.$store.state.oceanlifePage, ...this.$store.state.rabbitReplyFBPostPage].includes(
            this.selectedBot.pageid
          )) ||
        (this.selectedBot && this.selectedBot.unlock_ticket_3)
      )
    },
    previewMessage() {
      if (this.isBeacon) {
        return this.beaconCurrentIntentItems
      } else {
        if (this.tab == 'all') {
          return this.messages || [[]]
        } else {
          return this.multiMessages[`${this.tab}_messages`] || [[]]
        }
      }
    },
    ticket2showsave() {
      return !this.livechat || this.intent.q_val === 'exacts(intent_type_quick_message)'
    },
    isReadonly() {
      if (
        this.selectedBot.theme == 'tero' &&
        this.type === 'edit' &&
        (this.intent.intentname.includes('Answer__') ||
          this.intent.intentname.includes('Question__') ||
          this.intent.intentname.includes('Comment__'))
      ) {
        return true
      } else {
        return false
      }
    },
    roleJuzMatchMasterData() {
      if (this.isJuzmatchCrm) {
        return this.$store.state.juzMatchMasterDataCrm || []
      } else {
        return this.$store.state.juzMatchMasterDataSale || []
      }
    },
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    showReplyCommentSelectPost() {
      return this.isReplyComment && this.isCommentToInbox && !this.isLiveStream
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      ticketTags: 'ticketTags',
      ticketTagsFull: 'ticketTagsFull',
      setting: 'setting',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.tab)
      return messages
    },

    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },

    groupConversation: function () {
      var group = [{ id: 'all', name: 'All', status: true }]
      var groupConversation = this.$store.state.groupConversation
      group.push(...groupConversation)
      return group
    },

    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          try {
            result = tags(function (val) {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map(function (val) {
            return val.text
          })
        } catch (error) {
          console.error(error)
        }
        vm.intent.q_val = result.join(',')
      }
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'quick_reply', result.join(','))
      }
    },
    fb_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.fb_quick_reply && vm.intent.fb_quick_reply !== '') {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'fb_quick_reply', result.join(','))
      }
    },
    line_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.line_quick_reply && vm.intent.line_quick_reply !== '') {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'line_quick_reply', result.join(','))
      }
    },
    ig_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.ig_quick_reply && vm.intent.ig_quick_reply !== '') {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'ig_quick_reply', result.join(','))
      }
    },

    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {
              console.error(error)
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'usertags', result.join(','))
      }
    },

    deleteUserTags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.user_tags_delete && vm.intent.user_tags_delete !== '') {
          let user_tags_delete = []

          user_tags_delete = vm.intent.user_tags_delete.split(',')
          var result = []
          if (user_tags_delete) {
            try {
              result = user_tags_delete.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {
              console.error(error)
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'user_tags_delete', result.join(','))
      }
    },
    questions: function () {
      var result = []
      try {
        var questions = this.formatQuestionData(this.intent.q_val)
        // console.log(questions)
        if (questions.normal) {
          result = questions.normal.map((el) => {
            return el.text
          })
        } else if (questions.keyword) {
          result = questions.keyword.map((el) => {
            return el.text
          })
        } else if (questions.exactly) {
          result = questions.exactly.map((el) => {
            return el.text
          })
        } else if (questions.startwith) {
          result = questions.startwith.map((el) => {
            return el.text
          })
        } else if (questions.endwith) {
          result = questions.endwith.map((el) => {
            return el.text
          })
        } else if (questions.startandendwith) {
          result = questions.startandendwith.map((el) => {
            return el.text
          })
        }
        // result = questions.map(function(val) {
        //   return val.text
        // })
      } catch (error) {
        console.error(error)
      }
      return result
    },
    startTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime && this.intent.intentname !== '{first_announcement_message}') {
        if (vm.startTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.startTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 00:00:00'
      } else if (vm.startDate) {
        if (vm.startTime) {
          time = vm.startDate + ' ' + vm.startTime + ':00'
        } else {
          time = vm.startDate + ' 00:00:00'
        }
      }
      return time
    },
    endTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime && this.intent.intentname !== '{first_announcement_message}') {
        if (vm.endTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.endTime + ':59'
        else time = moment().format('YYYY-MM-DD') + ' 23:59:59'
      } else if (vm.endDate) {
        if (vm.endTime) {
          time = vm.endDate + ' ' + vm.endTime + ':59'
        } else {
          time = vm.endDate + ' 23:59:59'
        }
      }
      return time
    },
    intentgroup() {
      var hasValue = (val) => (val && val.length ? val : null)
      var duedate = null
      if (this.ticket.duedate.start) {
        duedate = moment(this.ticket.duedate.start).format('YYYY-MM-DD')
        if (this.ticket.duedate.starttime) {
          duedate = duedate + ' ' + this.ticket.duedate.starttime
        } else {
          duedate = duedate + ' 00:00'
        }
      }
      return {
        assigngroupid: hasValue(this.ticket.group ? this.ticket.group : null),
        assignsubgroupid: hasValue(this.ticket.subgroup ? this.ticket.subgroup : null),
        priority: hasValue(this.ticket.priority ? this.ticket.priority : null),
        duedate: duedate,
        day: this.ticket.day ? this.ticket.day : null,
        hour: this.ticket.hour ? this.ticket.hour : null,
        minute: this.ticket.minute ? this.ticket.minute : null,
        mood: this.ticket.mood ? this.ticket.mood : null,
        wrap_up: this.ticket.wrap_up ? this.ticket.wrap_up : null,
        wrap_up_route: this.ticket.wrap_up_route ? this.ticket.wrap_up_route : null,

        tags:
          this.ticket.tags && this.ticket.tags.length
            ? this.ticket.tags
                .map((el) => {
                  if (typeof el == 'string') {
                    return el
                  } else {
                    if (Object.hasOwnProperty.call(el, 'name')) {
                      return el.name
                    } else if (Object.hasOwnProperty.call(el, 'text')) {
                      return el.text
                    }
                  }
                })
                .filter(Boolean)
                .join(',')
            : null
      }
    },
    followIntentGroup() {
      var hasValue = (val) => (val && val.length ? val : null)
      var duedate = null
      if (
        this.intent.follow_up_intentgroup.duedate &&
        this.intent.follow_up_intentgroup.duedate.start
      ) {
        duedate = moment(this.intent.follow_up_intentgroup.duedate.start).format('YYYY-MM-DD')
        if (this.intent.follow_up_intentgroup.duedate.starttime) {
          duedate = duedate + ' ' + this.intent.follow_up_intentgroup.duedate.starttime
        } else {
          duedate = `${duedate} 00:00`
        }
      }
      return {
        assigngroupid: hasValue(
          this.intent.follow_up_intentgroup.group
            ? this.intent.follow_up_intentgroup.group.id
            : null
        ),
        assignsubgroupid: hasValue(
          this.intent.follow_up_intentgroup.subgroup
            ? this.intent.follow_up_intentgroup.subgroup.id
            : null
        ),
        priority: hasValue(
          this.intent.follow_up_intentgroup.priority
            ? this.intent.follow_up_intentgroup.priority.value
            : null
        ),
        duedate: duedate,
        day: this.intent.follow_up_intentgroup.day ? this.intent.follow_up_intentgroup.day : null,
        hour: this.intent.follow_up_intentgroup.hour
          ? this.intent.follow_up_intentgroup.hour
          : null,
        minute: this.intent.follow_up_intentgroup.minute
          ? this.intent.follow_up_intentgroup.minute
          : null,
        mood: this.intent.follow_up_intentgroup.mood
          ? this.intent.follow_up_intentgroup.mood
          : null,
        wrap_up: this.intent.follow_up_intentgroup.wrap_up
          ? this.intent.follow_up_intentgroup.wrap_up
          : null,
        wrap_up_route: this.intent.follow_up_intentgroup.wrap_up_route
          ? this.intent.follow_up_intentgroup.wrap_up_route
          : null,

        tags:
          this.intent.follow_up_intentgroup.tags && this.intent.follow_up_intentgroup.tags.length
            ? this.intent.follow_up_intentgroup.tags
                .map((el) => {
                  if (typeof el == 'string') {
                    return el
                  } else {
                    return el.name
                  }
                })
                .filter(Boolean)
                .join(',')
            : null
      }
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData
    },
    isJuzmatchSale() {
      return PAGE.JUZMATCH_SALE.includes(this.selectedBot.pageid)
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isRoots() {
      return PAGE.ROOTS.includes(this.selectedBot.pageid)
    },
    rootsCompanyMasterData() {
      return this.$store.state.rootsMasterData.company
    },
    rootsCompanyOptions: function () {
      let options = [{ id: 'all', name: 'All' }]
      if (this.rootsCompanyMasterData) {
        let tempCompanies = []
        this.rootsCompanyMasterData.forEach((el) => {
          tempCompanies.push({
            id: el.id,
            name: `${el.company_code} - ${el.company_name}`
          })
        })
        options.push(...tempCompanies)
      }
      return options
    },
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: el.name }
        })
      }

      return options
    },
    isAssetWise() {
      return ['assetwise'].includes(this.selectedBot.theme)
    },
    startTimeInput: {
      get() {
        return this.startTime
      },
      set(value) {
        if (value) {
          const [HH = '00', mm = '00'] = value.split(':')
          this.startTime = `${HH}:${mm}`
        } else {
          this.startTime = null
        }
      }
    },
    endTimeInput: {
      get() {
        return this.endTime
      },
      set(value) {
        if (value) {
          const [HH = '00', mm = '00'] = value.split(':')
          this.endTime = `${HH}:${mm}`
        } else {
          this.endTime = null
        }
      }
    },
    eventSetting: {
      get() {
        if (this.intent.event_setting) return this.intent.event_setting

        return {
          event_name: '',
          value: '',
          currency: 'THB',
          content_type: '',
          content_name: ''
        }
      },
      set(value) {
        this.intent.event_setting = value
      }
    },
    isRichMenuEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.LINE_RICH_MENU)
    },
    isSrichand() {
      return this.selectedBot.page_group === PAGE_GROUP.SRICHAND
    },
    isEventTrackingEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.EVENT_TRACKING)
    }
  },
  watch: {
    multiMessages: {
      handler(newVal) {
        this.conversationSocialChannelOptions.forEach((social) => {
          this.$set(this.intent, `${social.value}_val`, newVal[`${social.value}_messages`])
        })
      },
      deep: true
    },
    'intent.context_in': function (newVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    tickettags(val, prev) {
      if (val.length === prev.length) return

      this.ticket.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }
          this.$nextTick(() => {
            this.tagitems.push(v)
            this.$forceUpdate()
          })
        }

        return v
      })
    },
    value: function () {
      var vm = this
      vm.intent = cloneDeep(vm.value)

      vm.cached_intent = cloneDeep(vm.value)
      if (vm.intent.starttime) {
        var startTime = moment(vm.intent.starttime)
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = startTime.format('HH:mm')
      }
      if (vm.intent.endtime) {
        var endTime = moment(vm.intent.endtime)
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = endTime.format('HH:mm')
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    }
  },
  created: function () {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate() {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = moment(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      }
    })
  },

  async mounted() {
    const isUniqueIntent = async (value) => {
      try {
        const response = await intentApi.getIntent({
          params: {
            pageid: this.$store.state.selectedBot.pageid,
            search_intent: value,
            limit: 10,
            offset: 0,
            page_intent: this.isCommentToInbox ? 'comment' : 'conversation',
            sort_by: 'intentname',
            sort_type_available: 'asc'
          }
        })
        await handleResponse(response)
        let isValid = true,
          message = ''
        if (response.data.data) {
          const isFound = response.data.data.find(
            (intent) =>
              intent.intentname == value &&
              (this.type == 'add' || (this.type != 'add' && intent.id != this.intent.id))
          )
          isValid = isFound ? false : true
          message = isFound ? this.$t('duplicate_conversation_name') : ''
        } else {
          isValid = false
        }
        return {
          valid: isValid,
          data: {
            message
          }
        }
      } catch (error) {
        handleApiError(error)
      }
    }

    // The messages getter may also accept a third parameter that includes the data we returned earlier.
    Validator.extend('unique-intent', {
      validate: isUniqueIntent,
      getMessage: (field, params, data) => {
        return data.message
      }
    })

    let vm = this
    vm.getUserStatusList()
    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)
    vm.intent = cloneDeep(vm.value)

    this.not_reply_within_seconds = this.MinuteToSecond(this.intent.not_reply_within_seconds)

    if (vm.isBeacon) {
      vm.handleInitialBeaconIntent()
    }

    if (typeof this.intent.follow_up_within_seconds !== 'object') {
      this.intent.follow_up_within_seconds = {
        HH: ('0' + Math.floor(parseInt(this.intent.follow_up_within_seconds) / 60 / 60)).slice(-2),
        mm: (
          '0' + JSON.stringify((parseInt(this.intent.follow_up_within_seconds) / 60) % 60)
        ).slice(-2)
      }
    }

    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }
    const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`) &&
        this.intent[`${social.value}_val`]
      )
    })
    if (hasMultipleChannel) {
      this.showMultipleChannel = true
      this.conversationSocialChannelOptions.forEach((social) => {
        let json = [[]]
        try {
          json = Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`)
            ? this.isJsonParseable(this.intent[`${social.value}_val`])
              ? JSON.parse(this.intent[`${social.value}_val`])
              : this.intent[`${social.value}_val`]
            : [[]]
        } catch (error) {
          console.error(error)
        }
        this.multiMessages[`${social.value}_messages`] = json || [[]]

        const quick_replies = this.intent[`${social.value}_quick_reply`]
          ? this.intent[`${social.value}_quick_reply`].split(',')
          : []
        this.multiReplies[`${social.value}_quick_reply`] = quick_replies
        this.multiStringReplies[`${social.value}_quick_reply`] = ''
      })
      this.tab = hasMultipleChannel.value
    }

    const hasMultipleChannelFollowUp = this.conversationSocialChannelOptions.find((social) => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
        this.intent[`follow_up_${social.value}_val`] &&
        String(this.intent[`follow_up_${social.value}_val`]) !== 'null'
      )
    })
    if (hasMultipleChannelFollowUp) {
      this.showMultipleChannelFollowUp = true
    }

    this.timestamp = moment().format('x')

    if (vm.isCommentToInbox) {
      vm.remaining_reply = vm.intent.remaining_reply
      vm.notreplysameperson = vm.intent.notreplysameperson
      vm.isremainingreply = vm.intent.remaining_reply != null
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }
    if (!vm.intent.post_keywords) {
      vm.intent.post_keywords = ''
    } else {
      var post_keywords = []
      if (vm.intent.post_keywords && vm.intent.post_keywords !== '') {
        try {
          post_keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {
          console.error(error)
        }
      }
      this.$set(this.postidlist, 'post_keywords', post_keywords)
    }
    vm.cached_intent = cloneDeep(vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime =
      vm.intent.onlytime === null ? null : vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.intent.onlytime === null && vm.intent.time_setting) {
      vm.intent.time_setting = {
        Monday: vm.intent.time_setting.Monday || { status: true, openat: null, closeat: null },
        Tuesday: vm.intent.time_setting.Tuesday || { status: true, openat: null, closeat: null },
        Wednesday: vm.intent.time_setting.Wednesday || {
          status: true,
          openat: null,
          closeat: null
        },
        Thursday: vm.intent.time_setting.Thursday || { status: true, openat: null, closeat: null },
        Friday: vm.intent.time_setting.Friday || { status: true, openat: null, closeat: null },
        Saturday: vm.intent.time_setting.Saturday || { status: true, openat: null, closeat: null },
        Sunday: vm.intent.time_setting.Sunday || { status: true, openat: null, closeat: null }
      }
    } else {
      vm.intent.onlytime = vm.intent.onlytime === null ? false : vm.intent.onlytime
      if (vm.isBeacon) {
        if (vm.intent.start_date && vm.intent.end_date) {
          vm.intent.onlytime = false
          vm.intent.start_time = moment(vm.value.start_date).format('HH:mm')
          vm.intent.end_time = moment(vm.value.end_date).format('HH:mm')
        }
        if (
          vm.intent.start_time &&
          vm.intent.end_time &&
          vm.intent.start_date === null &&
          vm.intent.end_date === null
        ) {
          vm.intent.onlytime = true
        }
      }
      vm.intent.time_setting = {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: {
          status: true,
          openat: null,
          closeat: null
        },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      const nameIndex = names.findIndex((name) => {
        return vm.isBeacon ? name === vm.intent.campaign_name : name === vm.intent.intentname
      })
      if (nameIndex != -1) {
        names.splice(nameIndex, 1)
      }

      names = names.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        const group = vm.value.a_val.split('||')
        const newGroup = group.map((messages) => {
          const groupMessages = messages.split('#nl')
          const newMessage = groupMessages.map((message) => {
            if (!isNaN(message)) {
              return {
                type: 'text',
                text: message
              }
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              if (messageParsed.buttons) {
                messageParsed.buttons = messageParsed.buttons.filter(Boolean)
              }
              return {
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              }
            } else if (vm.isURL(message)) {
              return {
                type: 'image',
                image_url: message
              }
            } else {
              return {
                type: 'text',
                text: message
              }
            }
          })
          return newMessage
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square'
            }
          ]
        ]
      } else if (vm.value.a_type === 'generic') {
        //
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
    if (
      [
        'ticket',
        'ticket2',
        'studio7',
        'ustore',
        'tdtawandang',
        'cityfresh',
        ...this.$store.state.ticketThemeList
      ].includes(this.selectedBot.theme) ||
      [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
        this.selectedBot.pageid
      ) ||
      ['gpf', 'mtc'].includes(this.selectedBot.type) ||
      (this.selectedBot && this.selectedBot.unlock_ticket_3)
    ) {
      this.ticketinit()
    }
    if (
      this.livechat &&
      ([
        'ticket2',
        'studio7',
        'ustore',
        'tdtawandang',
        ...this.$store.state.ticketThemeList
      ].includes(this.selectedBot.theme) ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid) ||
        this.$store.state.toaPaintPage.includes(this.selectedBot.pageid)) &&
      this.type == 'add'
    ) {
      this.intent.q_val = 'exacts(intent_type_quick_message)'
    }

    if (['mitsuwebchat'].includes(this.selectedBot.theme)) {
      try {
        if (vm.$store.state.privilege.role == 'superadmin') {
          if (vm.intent.intentgroup) {
            let currentGroup = this.agentGroup.find((el) => el.id == vm.intent.intentgroup)
            this.$set(this.intent, 'intentgroup', currentGroup)
          } else {
            // vm.intent.intentgroup = '';
            this.$set(this.intent, 'intentgroup', '')
          }
        } else {
          let admingroupid = this.$store.state.admingroupid
          let currentGroup = this.agentGroup.find((el) => el.id == admingroupid)
          this.$set(this.intent, 'intentgroup', currentGroup)
        }
      } catch (error) {
        console.error(error)
      }
    }

    if (this.isAssetWise) {
      this.conversationGroups = Array.isArray(vm.intent.groups_conversation)
        ? vm.intent.groups_conversation
        : JSON.parse(vm.intent.groups_conversation || '[]')
    }

    if (!vm.$store.state.tags) {
      const tags = await vm.getUserTagList()
      vm.$store.state.tags = tags || []
    }
    this.tagOptions = this.$store.state.tags || []

    if (vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)) {
      if (vm.intent.group_conversation_id) {
        let groupConversationId = vm.intent.group_conversation_id
        let selectedConversationGroup = this.groupConversation.find(
          (el) => el.id == groupConversationId
        )
        this.$set(this.intent, 'group_conversation_id', selectedConversationGroup)
      } else {
        var group = [{ id: 'all', name: 'All', status: true }]
        this.$set(this.intent, 'group_conversation_id', group)
      }
    }

    if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
      let tempPositionOptions = []
      tempPositionOptions.push({ id: 0, engname: 'All', thname: 'All' })
      tempPositionOptions.push(...vm.$store.state.hopinnMasterData.position)
      vm.positionOptions = tempPositionOptions

      let tempAffiliationOptions = []
      tempAffiliationOptions.push({ id: 0, engname: 'All', thname: 'All' })
      tempAffiliationOptions.push(...vm.$store.state.hopinnMasterData.affiliation)
      vm.affiliationOptions = tempAffiliationOptions

      // vm.positionOptions = vm.$store.state.hopinnMasterData.position
      // vm.affiliationOptions = vm.$store.state.hopinnMasterData.affiliation

      if (vm.intent.custom_filter_2) {
        let current = vm.positionOptions.find((el) => el.engname == vm.intent.custom_filter_2)
        vm.$set(vm.intent, 'custom_filter_2', current)
      } else {
        vm.$set(vm.intent, 'custom_filter_2', { id: 0, engname: 'All', thname: 'All' })
      }

      if (vm.intent.custom_filter_1) {
        let current = vm.affiliationOptions.find((el) => el.engname == vm.intent.custom_filter_1)
        vm.$set(vm.intent, 'custom_filter_1', current)
      } else {
        vm.$set(vm.intent, 'custom_filter_1', { id: 0, engname: 'All', thname: 'All' })
      }
    }

    if (vm.isJuzmatchCrm || vm.isJuzmatchSale) {
      let current = this.roleJuzMatchMasterData.find((el) => el.id == vm.intent.intent_member_type)
      if (vm.intent.intent_member_type) {
        vm.$set(vm.intent, 'intent_member_type', current)
      } else {
        vm.$set(vm.intent, 'intent_member_type', null)
      }
    }

    if (vm.isRoots) {
      if (vm.intent.roots_company_id) {
        let companyId = vm.intent.roots_company_id
        let selectedCompany = this.rootsCompanyMasterData
          .filter((el) => el.id == companyId)
          .map((el) => {
            return {
              id: el.id,
              name: `${el.company_code} - ${el.company_name}`
            }
          })
        this.$set(this.intent, 'roots_company_id', selectedCompany)
      } else {
        const company = [{ id: 'all', name: 'All' }]
        this.$set(this.intent, 'roots_company_id', company)
      }
    }

    if (vm.isGpfBuddy) {
      const gpfBuddyMasterData = vm.gpfBuddyMasterData

      let tempCompanyOptions = []
      tempCompanyOptions.push({ company_code: 'All', company_name: 'All', groups: [] })
      tempCompanyOptions.push(...gpfBuddyMasterData)
      vm.gpfBuddyOption.companies = tempCompanyOptions

      let tempGroupOptions = []
      tempGroupOptions.push({ group_code: 'All', group_name: 'All', departments: [] })
      vm.gpfBuddyOption.groups = tempGroupOptions

      let tempDepartmentOptions = []
      tempDepartmentOptions.push({ department_code: 'All', department_name: 'All', positions: [] })
      vm.gpfBuddyOption.departments = tempDepartmentOptions

      let tempPositionOptions = []
      tempPositionOptions.push({ position_code: 'All', position_name: 'All' })
      vm.gpfBuddyOption.positions = tempPositionOptions

      let selectedCompany = null

      if (vm.intent.gpf_company_code) {
        selectedCompany = gpfBuddyMasterData.find((el) => {
          return el.company_code === vm.intent.gpf_company_code
        })
        vm.$set(vm.intent, 'gpf_company_code', selectedCompany)
      } else {
        vm.$set(vm.intent, 'gpf_company_code', {
          company_code: 'All',
          company_name: 'All',
          groups: []
        })
      }

      let selectedGroup = null
      if (vm.intent.gpf_group_code) {
        selectedGroup = selectedCompany.groups.find((el) => {
          return el.group_code === vm.intent.gpf_group_code
        })

        vm.$set(vm.intent, 'gpf_group_code', selectedGroup)
      } else {
        vm.$set(vm.intent, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
      }

      let selectedDepartment = null
      if (vm.intent.gpf_department_code) {
        selectedDepartment = selectedGroup.departments.find(
          (el) => el.department_code == vm.intent.gpf_department_code
        )
        vm.$set(vm.intent, 'gpf_department_code', selectedDepartment)
      } else {
        vm.$set(vm.intent, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
      }

      if (vm.intent.gpf_position_code) {
        let selectedPosition = selectedDepartment.positions.find(
          (el) => el.position_code == vm.intent.gpf_position_code
        )
        vm.$set(vm.intent, 'gpf_position_code', selectedPosition)
      } else {
        vm.$set(vm.intent, 'gpf_position_code', { position_code: 'All', position_name: 'All' })
      }

      if (
        vm.intent.gpf_group_code ||
        vm.intent.gpf_department_code ||
        vm.intent.gpf_position_code
      ) {
        vm.handleSetGpfBuddyOptions()
      }
    }
    vm.intent.follow_up_intentgroup =
      this.value && this.value.follow_up_intentgroup ? this.value.follow_up_intentgroup : ''
  },

  methods: {
    handleSelectBotProfile(botProfile) {
      if (botProfile) {
        this.intent = {
          ...this.intent,
          ...botProfile
        }
      } else {
        this.intent = {
          ...this.intent,
          bot_profile_id: null,
          bot_profile_name: null,
          bot_profile_pic: null
        }
      }
    },
    handleUpdateTicketInput(key, value) {
      this.$set(this.ticket, key, value)
    },
    handleChangeTicketTags(tags) {
      this.ticket.tags = tags
    },
    onClickClearVerifySlip() {
      const vm = this
      if (vm.messages[0].length !== 0) {
        vm.messages[0] = vm.messages[0].filter(
          (item) => !item.text.includes('{verify_slip.ref_no}')
        )
      }
      vm.changeTimestamp()
    },
    onClickVerifySlip({ eventPurchase }) {
      const vm = this
      if (!JSON.stringify(vm.messages[0]).includes('{verify_slip.ref_no}')) {
        const message = {
          text: `สถานะ: {verify_slip.result}

ชื่อผู้โอน: {verify_slip.transfer_name}
โอนจาก: {verify_slip.sending_bank}

ชื่อผู้รับ: {verify_slip.receive_name}
โอนถึง: {verify_slip.receiving_bank}

เลขอ้างอิง: {verify_slip.ref_no}
ยอดเงิน: {verify_slip.amount}

วันที่: {verify_slip.bank_transfer_date}
เวลา: {verify_slip.bank_transfer_time}`,
          type: 'text'
        }
        vm.messages[0].push({ ...message })
        vm.intent.verify_slip_setting = {
          ...vm.intent.verify_slip_setting,
          correct_a_val: [{ ...message }],
          incorrect_a_val: [{ ...message }],
          error_a_val: [{ ...message }],
          duplicate_a_val: [{ ...message }]
        }
      }
      if (eventPurchase) {
        this.eventSetting = {
          event_name: 'Purchase',
          value: '{number}',
          currency: 'THB'
        }
      } else {
        this.eventSetting = {
          event_name: '',
          value: '',
          currency: 'THB'
        }
      }
      this.purchaseEventManagementKey++
    },
    handleInitialBeaconIntent() {
      const vm = this
      try {
        const tempIntent = cloneDeep(vm.intent)

        const tempBeaconIds = tempIntent.specific_beacon_ids
        let selectedBeacon = []
        if (tempBeaconIds) {
          const tempArr = tempBeaconIds ? tempBeaconIds.split(',') : []

          selectedBeacon = tempArr.map((id) => {
            let objBeacon = vm.beaconBranchOptions.find((beacon) => beacon.beacon_id === id)
            return objBeacon
          })
        }

        let beaconType = 'beacon_enter'

        if (tempIntent.q_val) {
          const tempData = tempIntent.q_val

          if (tempData.includes('beacon_banner')) {
            beaconType = 'beacon_banner'
          }
        }

        if (tempIntent.not_reply_within_seconds) {
          vm.intent.not_reply_within_seconds = vm.MinuteToSecond(
            tempIntent.not_reply_within_seconds
          )
        }

        if (tempIntent.start_date) {
          vm.intent.start_date = moment(tempIntent.start_date).format('YYYY-MM-DD')
        }

        if (tempIntent.end_date) {
          vm.intent.end_date = moment(tempIntent.end_date).format('YYYY-MM-DD')
        }

        if (tempIntent.start_time) {
          const arrTime = tempIntent.start_time.split(':')
          vm.intent.start_time = `${arrTime[0]}:${arrTime[1]}`
        }

        if (tempIntent.end_time) {
          const arrTime = tempIntent.end_time.split(':')
          vm.intent.end_time = `${arrTime[0]}:${arrTime[1]}`
        }

        const tempBeaconData = {
          beacon_ids: selectedBeacon,
          beacon_type: beaconType,
          group_audience: tempIntent.line_beacon_audience_group_ids
        }

        vm.beaconData = tempBeaconData

        const isAnswerGroupKey = [
          'first_stage',
          'second_stage',
          'third_stage',
          'fourth_stage',
          'fifth_stage'
        ]

        const tempData = []
        let countAnswerGroup = 1
        isAnswerGroupKey.forEach((key) => {
          if (tempIntent[key]) {
            tempData.push(tempIntent[key])
            countAnswerGroup++
          }
        })

        vm.alternativeGroupMessages = tempData.length > 0 ? tempData : [[[]]]

        const isQuickReplyKey = [
          'quick_reply_first_stage',
          'quick_reply_second_stage',
          'quick_reply_third_stage',
          'quick_reply_fourth_stage',
          'quick_reply_fifth_stage'
        ]

        const tempQuickReplies = []

        isQuickReplyKey.forEach((key, index) => {
          if (index + 1 < countAnswerGroup) {
            if (tempIntent[key]) {
              tempQuickReplies.push([tempIntent[key]])
            } else {
              tempQuickReplies.push([])
            }
          }
        })

        vm.beaconQuickReplies = tempQuickReplies.length > 0 ? cloneDeep(tempQuickReplies) : [[]]
      } catch (error) {
        console.error(error)
      }
    },
    showAdvancedMenu(type) {
      if (this.hideAdvanceOptions) {
        return !this.hideAdvanceOptions.includes(type)
      } else {
        return true
      }
    },
    changeFollowUpSetting(setting) {
      this.showMultipleChannelFollowUp = setting.showMultipleChannel || false
    },
    onSelectStatus(value) {
      this.intent.userstatus = value
    },
    async getUserTagList(query) {
      try {
        const response = await api.getUserTagList({
          limit: 100,
          offset: 0,
          filter_name: query || undefined
        })

        if (response && response.result) {
          return response.result.map((item) => {
            return item.name
          })
        } else {
          return []
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    countBeaconID(beacon) {
      return `(${beacon.split(',').length})`
    },
    async changeSetting(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        Object.hasOwnProperty.call(payload, 'showMultipleChannel')
      ) {
        if (
          this.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          let cloneMessages = null
          if (this.isWelcome) {
            try {
              await this.$nextTick()
              let { messages } = this.$store.getters.welcomeMessage('all')
              cloneMessages = messages
            } catch (error) {
              console.error(error)
            }
          } else {
            cloneMessages = this.messages
          }

          this.conversationSocialChannelOptions.forEach((social) => {
            if (social.value == 'fb' || social.value == 'ig' || social.value == 'whatsapp') {
              this.$set(
                this.multiMessages,
                `${social.value}_messages`,
                cloneDeep(
                  cloneMessages.map((el) => {
                    return el.filter((sel) => {
                      return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                    }, [])
                  }, [])
                )
              )
            } else {
              this.$set(this.multiMessages, `${social.value}_messages`, cloneDeep(cloneMessages))
            }
            this.$set(this.intent, `${social.value}_quick_reply`, this.intent.quick_reply)
          })
        }
        this.showMultipleChannel = payload.showMultipleChannel

        if (this.showMultipleChannel) this.tab = 'fb'
        else this.tab = 'all'
      }
    },
    changeRemainingReply(value) {
      if (value) {
        this.remaining_reply = 0
      } else {
        this.remaining_reply = null
      }
    },
    formatQuestionData: function (text) {
      var questions = text && text !== '' ? text.split(',') : []
      var result = {
        normal: [],
        keyword: [],
        exactly: [],
        startwith: [],
        endwith: [],
        startandendwith: []
      }
      if (questions) {
        questions.forEach(function (question) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.exactly.push({ text: keyword })
          } else {
            result.normal.push({ text: question })
          }
        })
      }
      return result
    },
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    async ticketinit() {
      this.loadingIntentGroup = true
      try {
        try {
          if (this.intent.intentgroup) {
            let ticket
            if (this.IsJsonString(this.intent.intentgroup)) {
              ticket = JSON.parse(this.intent.intentgroup)
            } else {
              ticket = this.intent.intentgroup
            }
            this.ticket = Object.assign(this.ticket, {
              group: ticket.assigngroupid,
              subgroup: ticket.assignsubgroupid,
              priority: ticket.priority,
              tags: ticket.tags
                ? ticket.tags.split(',').map((el) => {
                    return { name: el }
                  })
                : []
            })
            if (ticket.duedate) {
              this.ticket.duedate = {
                start: moment(this.ticket.duedate).format('YYYY-MM-DD'),
                starttime: moment(this.ticket.duedate).format('HH:mm'),
                end: ''
              }
            }
            if (ticket.day) {
              this.ticket.day = ticket.day
            }
            if (ticket.hour) {
              this.ticket.hour = ticket.hour
            }
            if (ticket.minute) {
              this.ticket.minute = ticket.minute
            }
            if (ticket.mood) {
              this.ticket.mood = ticket.mood
            }
            if (ticket.wrap_up) {
              this.ticket.wrap_up = ticket.wrap_up
            }
            if (ticket.wrap_up_route) {
              this.ticket.wrap_up_route = ticket.wrap_up_route
            }
          }
        } catch (error) {
          console.error(error)
        }
      } catch (error) {
        console.error(error)
      } finally {
        await this.$nextTick()
        this.loadingIntentGroup = false
      }
    },
    async tagsedit(index, item) {
      this.showEditTicketTag = !this.showEditTicketTag
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        //save tag
        const result = await this.handleEditTicketTag(item, this.tagediting)
        if (result) {
          //clear tag
          const tagIndex = this.ticketTagsFull.findIndex((el) => el.id != item.id)
          if (tagIndex != -1) {
            const tags = this.ticketTagsFull
            tags[tagIndex] = this.tagediting
            this.$store.commit('SET_TICKET_TAGS_FULL', tags)
          }
          this.tagediting = null
          this.index = -1
        }
      }
    },
    async handleEditTicketTag(item, newVal) {
      try {
        const tag = this.ticketTagsFull.find((tag) => {
          return tag && item && tag.name.toLowerCase() == item.name.toLowerCase()
        })

        if (tag && newVal) {
          const response = await ticketApi.putEditTicketTag({
            data: { pageid: this.selectedBot.pageid, id: tag.id, ticket_tag: newVal.name }
          })
          await handleResponse(response)
          return true
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (this.ticket.duedate.end && moment(this.ticket.duedate.end).isBefore(value)) {
        this.ticket.duedate.end = value
      }
      vm.ticket.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup() {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },
    onSelectedDepartment(val) {
      this.$set(this.intent, 'intentgroup', val)
    },
    saveFilterPost(payload) {
      this.$set(this.intent, 'postidlist', payload.includes)
      this.$set(this.intent, 'exceptpostidlist', payload.excludes)
      this.$set(this.intent, 'post_keywords', payload.post_keywords)

      var includes = []
      var excludes = []
      var post_keywords = []
      if (payload.includes) {
        try {
          includes = JSON.parse(payload.includes)
        } catch (error) {
          includes = payload.includes.split(',')
        }
      }
      if (payload.excludes) {
        try {
          excludes = JSON.parse(payload.excludes)
        } catch (error) {
          excludes = payload.excludes.split(',')
        }
      }
      if (payload.post_keywords) {
        try {
          post_keywords = JSON.parse(payload.post_keywords)
        } catch (error) {
          post_keywords = payload.post_keywords.split(',')
        }
      }
      this.postidlist = { includes, excludes, post_keywords }
    },
    changeOnlytime() {
      this.$forceUpdate()
    },
    toggleLineNotifyStatus: function () {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
    },
    addGeneric: function () {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true
      })
    },
    sendToLivechat() {
      var messages = this.checkEmptyMessage(this.messages)
      var a_val = JSON.stringify(messages)
      this.$emit('sendtolivechat', { ...this.intent, a_val })
    },
    MinuteToSecond(minute) {
      var m = null
      if (typeof minute === 'string') {
        m = parseFloat(minute)
      }
      return Math.floor(m / 60) ? JSON.stringify(Math.floor(m / 60)) : null
    },
    SecondToMinute(second) {
      var s = null
      if (typeof second === 'string') {
        s = parseFloat(second)
      }
      return Math.floor(s * 60) ? JSON.stringify(Math.floor(s * 60)) : null
    },
    getAnswerGroupKey(value) {
      let tempGroupKey = null
      switch (value) {
        case 1:
          tempGroupKey = 'second_stage'
          break
        case 2:
          tempGroupKey = 'third_stage'
          break
        case 3:
          tempGroupKey = 'fourth_stage'
          break
        case 4:
          tempGroupKey = 'fifth_stage'
          break
        default:
          tempGroupKey = 'first_stage'
          break
      }

      return tempGroupKey
    },
    handleTransformDataAlternativeGroup() {
      const vm = this
      const tempData = vm.alternativeGroupMessages
      let data = {
        first_stage: null,
        second_stage: null,
        third_stage: null,
        fourth_stage: null,
        fifth_stage: null
      }

      tempData.forEach((item, index) => {
        const key = vm.getAnswerGroupKey(index)
        data[key] = cloneDeep(item)
      })
      return data
    },
    getQuickReplyKey(value) {
      let quickReplyKey = null
      switch (value) {
        case 1:
          quickReplyKey = 'quick_reply_second_stage'
          break
        case 2:
          quickReplyKey = 'quick_reply_third_stage'
          break
        case 3:
          quickReplyKey = 'quick_reply_fourth_stage'
          break
        case 4:
          quickReplyKey = 'quick_reply_fifth_stage'
          break
        default:
          quickReplyKey = 'quick_reply_first_stage'
          break
      }

      return quickReplyKey
    },
    handleTransformDataQuickReplies() {
      const vm = this
      const tempData = vm.beaconQuickReplies
      let data = {
        quick_reply_first_stage: null,
        quick_reply_second_stage: null,
        quick_reply_third_stage: null,
        quick_reply_fourth_stage: null,
        quick_reply_fifth_stage: null
      }

      tempData.forEach((item, index) => {
        const key = vm.getQuickReplyKey(index)
        const tempItem = cloneDeep(item)
        data[key] = tempItem[0]
      })
      return data
    },
    saveIntent() {
      const vm = this
      const tempHour =
        vm.intent.follow_up_within_seconds && vm.intent.follow_up_within_seconds.HH
          ? parseInt(vm.intent.follow_up_within_seconds.HH)
          : parseInt('00')

      const followUpWithinSeconds =
        vm.intent.follow_up_within_seconds && vm.intent.follow_up_within_seconds.mm
          ? (tempHour * 60 +
              parseInt(
                vm.intent.follow_up_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_within_seconds.mm
              )) *
            60
          : null

      let data = {
        pageid: vm.selectedBot.pageid,
        ...vm.intent,

        a_type: 'json',
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime:
          vm.intent.onlytime === null ? null : vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null,
        post_keywords: vm.intent.post_keywords ? vm.intent.post_keywords : '',
        follow_up_intentgroup: vm.followIntentGroup,
        follow_up_status: vm.intent.follow_up_status ? vm.intent.follow_up_status : null,
        follow_up_within_seconds: followUpWithinSeconds,
        follow_up_val: !this.showMultipleChannelFollowUp
          ? JSON.stringify(this.checkEmptyMessage(this.intent.follow_up_val || []))
          : null,
        follow_up_quick_reply: vm.intent.follow_up_quick_reply
          ? vm.intent.follow_up_quick_reply
          : null,
        follow_up_type: 'json',
        time_setting: this.updateOpeningHours(vm.intent.time_setting)
      }

      if (this.eventSetting.event_name) {
        data.event_setting = this.eventSetting
      }

      if (data.onlytime !== null) {
        delete data.time_setting
      }

      if (vm.selectedBot.theme == 'toa') {
        // const currentTags = vm.tickettags.map((x) => x.name)
        const currentTags = vm.ticket.tags.map((el) => (typeof el === 'string' ? el : el.name))
        vm.$store.dispatch('updateTicketTags', currentTags)
      }

      if (!vm.isBeacon) {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname != '' && vm.selectedBot.uu_areaname != null) {
            data.intentgroup = vm.selectedBot.uu_areaname
          } else if (vm.selectedBot.uu_areaname == '' || vm.selectedBot.uu_areaname == null) {
            data.intentgroup = vm.intent.intentgroup == 'ทุกพื้นที่' ? '' : vm.intent.intentgroup
          }
        } else if (
          [
            'ticket',
            'ticket2',
            'studio7',
            'ustore',
            'tdtawandang',
            'cityfresh',
            ...vm.$store.state.ticketThemeList
          ].includes(vm.selectedBot.theme) ||
          [...vm.$store.state.ticketPageid].includes(vm.selectedBot.pageid) ||
          ['gpf', 'mtc'].includes(vm.selectedBot.type) ||
          (vm.selectedBot && vm.selectedBot.unlock_ticket_3)
        ) {
          data.intentgroup = vm.intentgroup
        } else if (['mitsuwebchat'].includes(vm.selectedBot.theme)) {
          data.intentgroup = vm.intent.intentgroup ? vm.intent.intentgroup.id : ''
        } else if ([...vm.$store.state.toaPaintPage].includes(vm.selectedBot.pageid)) {
          data.intentgroup = vm.intentgroup

          if (vm.intent.group_conversation_id && vm.intent.group_conversation_id.id !== 'all') {
            data.group_conversation_id = vm.intent.group_conversation_id.id
          } else {
            data.group_conversation_id = null
          }
        }
      }

      if (vm.isBeacon) {
        const intentGroupBeacon = vm.handleTransformDataAlternativeGroup()
        const quickRepliesBeacon = vm.handleTransformDataQuickReplies()
        Object.assign(data, intentGroupBeacon)
        Object.assign(data, quickRepliesBeacon)

        const tempSelectedBeaconIds = cloneDeep(vm.beaconData.beacon_ids)
        let selectedBeaconIds = ''
        if (tempSelectedBeaconIds && tempSelectedBeaconIds.length > 0) {
          selectedBeaconIds = tempSelectedBeaconIds.map((el) => el.beacon_id).toString()
        }
        data.specific_beacon_ids = selectedBeaconIds
        data.q_val =
          vm.beaconData.beacon_type === 'beacon_enter'
            ? 'exacts(beacon_enter)'
            : 'exacts(beacon_banner)'
        data.line_beacon_audience_group_ids = cloneDeep(vm.beaconData.group_audience)

        data.not_reply_within_seconds = vm.intent.not_reply_within_seconds
          ? vm.SecondToMinute(vm.intent.not_reply_within_seconds)
          : null
        data.not_reply_within_times =
          vm.intent.not_reply_within_times === '' ? null : vm.intent.not_reply_within_times
        data.frequency_per_day =
          vm.intent.frequency_per_day === '' ? null : vm.intent.frequency_per_day
        data.campaign_name = vm.intent.campaign_name
        data.status = vm.intent.status

        if (vm.intent.start_date) {
          const startDate = `${vm.intent.start_date} ${vm.intent.start_time}:00`
          data.start_date = moment(startDate).format('YYYY-MM-DD HH:mm')

          const endDate = `${vm.intent.end_date} ${vm.intent.end_time}:00`
          data.end_date = moment(endDate).format('YYYY-MM-DD HH:mm')
        } else {
          data.start_date = null
          data.end_date = null
        }

        data.start_time = vm.intent.start_time
        data.end_time = vm.intent.end_time
      } else {
        data.intentname = vm.intent.intentname.trim()
      }

      if (this.showMultipleChannel) {
        vm.conversationSocialChannelOptions.forEach((social) => {
          vm.$set(
            data,
            `${social.value}_val`,
            // eslint-disable-next-line no-irregular-whitespace
            JSON.stringify(vm.multiMessages[`${social.value}_messages`]).replace(/ /gim, ' ')
          )
          vm.$set(data, `${social.value}_quick_reply`, vm.intent[`${social.value}_quick_reply`])
        })
      } else {
        vm.conversationSocialChannelOptions.forEach((social) => {
          if (Object.prototype.hasOwnProperty.call(data, `${social.value}_val`)) {
            delete data[`${social.value}_val`]
          }
          if (Object.prototype.hasOwnProperty.call(data, `${social.value}_quick_reply`)) {
            delete data[`${social.value}_quick_reply`]
          }
        })
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.userstatus = vm.intent.userstatus
        data.usertags = vm.intent.usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.linenoti_text = vm.intent.linenoti_text
        data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }
      if (
        ['studio7', 'ticket2', 'ustore', 'tdtawandang', 'cityfresh'].includes(
          vm.selectedBot.theme
        ) ||
        vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)
      ) {
        if (data.intentgroup && data.intentgroup.assigngroupid) {
          data.context_out = 'contactadmin'
        }
      }

      if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
        data.custom_filter_1 =
          vm.intent.custom_filter_1 && vm.intent.custom_filter_1.engname !== 'All'
            ? vm.intent.custom_filter_1.engname
            : ''
        data.custom_filter_2 =
          vm.intent.custom_filter_2 && vm.intent.custom_filter_2.engname !== 'All'
            ? vm.intent.custom_filter_2.engname
            : ''
      }

      if (vm.isJuzmatchCrm || vm.isJuzmatchSale) {
        data.intent_member_type =
          vm.intent.intent_member_type && vm.intent.intent_member_type.name !== 'All'
            ? vm.intent.intent_member_type.id
            : ''
      }

      if (vm.isGpfBuddy) {
        data.gpf_company_code =
          vm.intent.gpf_company_code && vm.intent.gpf_company_code.company_code !== 'All'
            ? vm.intent.gpf_company_code.company_code
            : null
        data.gpf_group_code =
          vm.intent.gpf_group_code && vm.intent.gpf_group_code.group_code !== 'All'
            ? vm.intent.gpf_group_code.group_code
            : null
        data.gpf_department_code =
          vm.intent.gpf_department_code && vm.intent.gpf_department_code.department_code !== 'All'
            ? vm.intent.gpf_department_code.department_code
            : null
        data.gpf_position_code =
          vm.intent.gpf_position_code && vm.intent.gpf_position_code.position_code !== 'All'
            ? vm.intent.gpf_position_code.position_code
            : null
      }
      if (vm.isRoots) {
        if (
          vm.intent.roots_company_id &&
          vm.intent.roots_company_id.id &&
          vm.intent.roots_company_id.id !== 'all'
        ) {
          data.roots_company_id = vm.intent.roots_company_id.id
        } else if (
          vm.intent.roots_company_id &&
          vm.intent.roots_company_id[0] &&
          vm.intent.roots_company_id[0].id &&
          vm.intent.roots_company_id[0].id !== 'all'
        ) {
          data.roots_company_id = vm.intent.roots_company_id[0].id
        } else {
          delete data['roots_company_id']
        }
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          // eslint-disable-next-line no-irregular-whitespace
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }

          // eslint-disable-next-line no-irregular-whitespace
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          if (!vm.isBeacon) {
            var messages = vm.checkEmptyMessage(vm.messages)
            data.a_val = JSON.stringify(messages)
          }
        }
      }

      if (this.showMultipleChannelFollowUp) {
        vm.conversationSocialChannelOptions.forEach((social) => {
          if (social.value !== 'ms_team') {
            data[`follow_up_${social.value}_val`] =
              typeof vm.intent[`follow_up_${social.value}_val`] != 'string'
                ? // eslint-disable-next-line no-irregular-whitespace
                  JSON.stringify(vm.intent[`follow_up_${social.value}_val`]).replace(/ /gim, ' ')
                : vm.intent[`follow_up_${social.value}_val`]

            data[`follow_up_${social.value}_quick_reply`] = vm.intent[
              `follow_up_${social.value}_replies`
            ]
              ? vm.intent[`follow_up_${social.value}_replies`].map((item) => item.text).join(',')
              : vm.intent[`follow_up_${social.value}_quick_reply`]
          }
        })
      } else {
        vm.conversationSocialChannelOptions.forEach((social) => {
          data[`follow_up_${social.value}_val`] = null
          data[`follow_up_${social.value}_quick_reply`] = ''
        })
      }

      if (this.isAssetWise) {
        data.groups_conversation = this.conversationGroups
      }

      vm.$validator
        .validateAll()
        .then(async (result) => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }

          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            if (!vm.isBeacon) {
              try {
                if (vm.intent.onlytime === null) {
                  data.starttime = null
                  data.endtime = null
                  Object.assign(data, { time_setting: data.time_setting })
                }

                const response = await api.addIntent(data, null, true)
                vm.$store.commit('CLEAR_LOADING')

                if (response && response.data && response.data.responsecode === 200) {
                  data.id = response.data.id
                  vm.$emit('input', data)
                  vm.$emit('saveIntent', data)
                  vm.$emit('close', null)
                  vm.intent = cloneDeep(vm.intentTemplate())
                  vm.cached_intent = Object.assign({}, vm.intent)
                } else if (response && response.data && response.data.responsecode === 400) {
                  if (response.data.result === 'DUPLICATE_INTENT_NAME') {
                    vm.$swal({
                      title: vm.$t('Error'),
                      type: 'error',
                      text: vm.$t('duplicate_conversation_name'),
                      confirmButtonText: vm.$t('Confirm')
                    })
                  } else {
                    console.log(response.data.result)
                  }
                } else {
                  console.log(response)
                }
              } catch (error) {
                vm.$store.commit('CLEAR_LOADING')
                console.error(error)
              }
            } else {
              const response = await vm.addIntentBeacon(data)

              if (response && response.status === 200) {
                vm.$emit('input', data)
                vm.$emit('saveIntent', data)
                vm.$emit('close', null)
                vm.$store.dispatch('loading')
                vm.intent = cloneDeep(vm.intentTemplate())
                vm.cached_intent = Object.assign({}, vm.intent)
              }
            }
          } else {
            data['id'] = vm.intent.id

            if (!vm.isBeacon) {
              vm.$store.dispatch('loading')
              if (vm.intent.onlytime === null) {
                data.starttime = null
                data.endtime = null
                Object.assign(data, { time_setting: data.time_setting })
              }
              api.editIntent(data, function (error) {
                if (error) {
                  vm.$store.commit('CLEAR_LOADING')
                  console.error(error)

                  return
                }
                vm.$emit('input', data)
                // console.log(data)
                vm.$emit('saveIntent', data)
                vm.cached_intent = Object.assign({}, vm.intent)

                vm.$store.commit('CLEAR_LOADING')
              })
            } else {
              vm.$store.dispatch('loading')
              const response = await vm.updateIntentBeacon(data)
              vm.$store.commit('CLEAR_LOADING')

              if (response && response.status === 200) {
                vm.$emit('input', data)
                vm.$emit('saveIntent', data)
                vm.cached_intent = Object.assign({}, vm.intent)
              }
            }
          }
        })
        .catch((err) => {
          vm.$store.commit('CLEAR_LOADING')
          console.error(err)
        })
    },
    async addIntentBeacon(data) {
      const vm = this
      try {
        let tempData = data
        if (tempData.onlytime) {
          tempData = {
            ...tempData,
            start_date: null,
            end_date: null
          }
        } else {
          tempData = {
            ...tempData,
            start_time: null,
            end_time: null
          }
        }
        vm.$store.dispatch('loading')
        const response = await beaconApi.postAddIntentBeacon({ data: tempData })
        vm.$store.commit('CLEAR_LOADING')
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === 'CREATE_LINE_BEACON_CAMPAIGN_FAILED'
        ) {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: vm.$t('duplicate_conversation_name'),
            confirmButtonText: vm.$t('Confirm')
          })
        }
        return null
      }
    },
    async updateIntentBeacon(data) {
      const vm = this
      try {
        let tempData = data
        if (tempData.onlytime) {
          tempData = {
            ...tempData,
            start_date: null,
            end_date: null
          }
        } else {
          tempData = {
            ...tempData,
            start_time: null,
            end_time: null
          }
        }
        vm.$store.dispatch('loading')
        const response = await beaconApi.putUpdateIntentBeacon({ data: tempData })
        vm.$store.dispatch('loading')
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        vm.$store.dispatch('loading')
        return null
      }
    },

    cancelEdit: function () {
      var vm = this
      vm.intent = cloneDeep(vm.cached_intent)
      vm.$emit('close', null)
    },
    closeShowSelectBeacon() {
      this.showSelectBeacon = false
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.isDuplicate) {
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkQuickReply(obj) {
      this.errorTag = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.type == 'add' && this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function () {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function () {
      let intentstatus = null
      if (this.isBeacon) {
        intentstatus = this.intent.status ? this.intent.status : false
        this.$set(this.intent, 'status', !intentstatus)
      } else {
        intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
        this.$set(this.intent, 'intentstatus', !intentstatus)
      }
    },
    onChangeIntentOnlyTime: function () {
      let onlytime =
        this.intent.onlytime === null ? null : this.intent.onlytime ? this.intent.onlytime : false

      this.$set(this.intent, 'onlytime', !onlytime)
    },
    addIntentPrefill: function (prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition)
      ].join('')
    },
    addEmoji: function (emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function (type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function (newTags) {
      this.replies = newTags
      // console.log(newTags,this.replies)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    addDeleteUserTags: function (newTags) {
      this.deleteUserTags = newTags
    },
    onSelected(option) {
      this.selected = option.item
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter((item) => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData
        }
      ]
    },
    getAdminGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSearchTag({ event, onComplete }) {
      const vm = this
      if (vm.updateSearchTagTimeout) {
        clearTimeout(vm.updateSearchTagTimeout)
      }
      vm.updateSearchTagTimeout = setTimeout(async () => {
        try {
          const tags = await vm.getUserTagList(event)
          onComplete(tags)
        } catch (error) {
          console.error(error)
        }
        vm.updateSearchTagTimeout = null
      }, 2000)
    },
    handleSetGpfBuddyOptions() {
      const vm = this
      const selectedCompany = vm.intent.gpf_company_code
      const selectedGroup = vm.intent.gpf_group_code
      const selectedDepartment = vm.intent.gpf_department_code

      if (selectedCompany && selectedCompany.company_code !== 'All') {
        const tempGroupOptions = [
          { group_code: 'All', group_name: 'All', departments: [] },
          ...selectedCompany.groups
        ]
        vm.gpfBuddyOption.groups = tempGroupOptions
      }

      if (selectedGroup && selectedGroup.group_code !== 'All') {
        const tempDepartmentOptions = [
          {
            department_code: 'All',
            department_name: 'All',
            positions: []
          },
          ...selectedGroup.departments
        ]
        vm.gpfBuddyOption.departments = tempDepartmentOptions
      }

      if (selectedDepartment && selectedDepartment.department_code !== 'All') {
        const tempPositionOptions = [
          { position_code: 'All', position_name: 'All' },
          ...selectedDepartment.positions
        ]
        vm.gpfBuddyOption.positions = tempPositionOptions
      }
    },
    onChangeGpfBuddyOptions(type) {
      const vm = this
      if (type === 'company') {
        vm.$set(vm.intent, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
        vm.$set(vm.intent, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'group') {
        vm.$set(vm.intent, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'department') {
        vm.$set(vm.intent, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      }

      vm.handleSetGpfBuddyOptions()
    },
    handleUpdateBeaconQuickReply(payload) {
      this.beaconQuickReplies = []
      this.beaconQuickReplies.push(...payload)
    },
    handleSetBeaconPreviewIntent(value) {
      const tempIntent = []
      tempIntent.push(value)
      this.beaconCurrentIntentItems = tempIntent
    },
    updateOpeningHours(obj) {
      for (const day in obj) {
        if (obj.hasOwnProperty(day)) {
          obj[day].openat = !obj[day].status ? null : obj[day].openat ? obj[day].openat : '00:00+07'
          obj[day].closeat = !obj[day].status
            ? null
            : obj[day].closeat
            ? obj[day].closeat
            : '24:00+07'
        }
      }
      return obj
    },
    checkOverTime() {
      const today = moment().format('YYYY-MM-DD')
      const startTime = this.startTimeInput || '00:00'
      const startDate = this.startDate
        ? moment(`${this.startDate} ${startTime}`)
        : moment(`${today} ${startTime}`)
      const endTime =
        this.endTimeInput && this.endTimeInput !== '24:00' ? this.endTimeInput : '23:59:59'
      const endDate = this.endDate
        ? moment(`${this.endDate} ${endTime}`)
        : moment(`${today} ${endTime}`)

      return startDate && endDate && startDate > endDate
    },
    handleStartdate() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.endDate = null
        this.endTime = null
      }
      this.openStartDate = false
    },
    handleEndDate() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.startDate = null
        this.startTime = null
      }
      this.openEndDate = false
    },
    handleStartTime() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.endTime = null
      }
      this.openStartDate = false
    },
    handleEndTime() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.startTime = null
      }
      this.openEndDate = false
    },
    changeTimestamp() {
      this.timestamp = moment().format('x')
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    handlePurchaseEventManagementInput(intent) {
      this.intent = intent
    }
  }
}
</script>
<style lang="scss" scope>
.success--text {
  color: #ff706b !important;
  caret-color: #ff706b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue